module.exports = __webpack_public_path__ + "static/media/calcon-logo-white-2x.fa4e4317.07c3f476.png";